import * as THREE from 'three';

const _a = new THREE.Vector3();
const _b = new THREE.Vector3();

/** Sphere vs sphere collision using `userData.radius` (fallback 1). */
export function spheresCollide(a: THREE.Object3D, b: THREE.Object3D): boolean {
  const ra = typeof a.userData.radius === 'number' ? a.userData.radius : 1;
  const rb = typeof b.userData.radius === 'number' ? b.userData.radius : 1;
  a.getWorldPosition(_a);
  b.getWorldPosition(_b);
  return _a.distanceTo(_b) < ra + rb;
}
